import { Link } from 'react-router-dom';

const navigation = [
  { name: 'Get Quote', to: '/getQuote', current: false },
  // { name: "My Documents", to: "/user/documents", current: false },
  { name: 'History', to: '/history', current: false },
  { name: 'Capabilities', to: '/capabilites', current: false },
  { name: 'About us', to: '/about', current: false },
  { name: 'Notifications', to: '/user/notification', current: false },
  { name: 'Help', to: '/help', current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Sidebar() {
  return (
    <>
      <div className="flex flex-col w-56 px-5">
        <div className="overflow:hidden flex-1 my-4">
          <div className="flex flex-col">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.to}
                className={classNames(
                  item.current
                    ? 'bg-gradient-to-r from-[#8B5CF6] to-[#60A5FA] text-black text-left'
                    : 'text-black hover:bg-gradient-to-r hover:from-[#8B5CF6] hover:to-[#60A5FA] hover:text-black hover:text-white',
                  'rounded-full px-8 py-2 text-[18px] text-left mx-3 my-1',
                )}
                aria-current={item.current ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
